import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsKitesurfNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M11.6 15.97l3.64-1.93-.48-.88-3.63 1.93zM11.64.5a7.81 7.81 0 00-3.41.91l-.53.28c-.01.01-.02.01-.03.02l-2.64 1.4a7.821 7.821 0 00-2.65 2.3 2.758 2.758 0 00.69 3.92l7.38 4.98 1.31-.69-5.99-6.47a1.741 1.741 0 01-.33-1.91c-.413.336-.785.72-1.107 1.144.039.35.16.687.355.982L3.25 8.13a1.563 1.563 0 01-.37-.79A1.731 1.731 0 013.18 6a7.9 7.9 0 016.03-3.08c.14-.005.28.002.42.02a1.74 1.74 0 011.55 1.35l2 8.57 1.32-.7V3.27a2.76 2.76 0 00-.84-1.99A2.865 2.865 0 0011.64.5zM5.328 8.158L9.04 12.15 4.1 8.82zM9.64 1.93a.684.684 0 00-.15 0 6.952 6.952 0 012.24-.43 1.742 1.742 0 011.67 1.232l-1.454.774A2.669 2.669 0 009.64 1.93zm3.86 7.88l-1.25-5.333 1.25-.664z"
        fill=""
      />
    </svg>
  )
);
SvgSportsKitesurfNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsKitesurfNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsKitesurfNormalXsmall;
